import React, { useCallback, useEffect, useState } from "react";
import L from "leaflet";
import {
  MapContainer,
  TileLayer,
  FeatureGroup,
  LayersControl,
} from "react-leaflet";
import FullscreenControl from "react-leaflet-fullscreen-plugin";
import { MAPS_CONFIG, renderGeoJson, cleanPreviousHoleLayers } from "./utils";

// Set global Leaflet options
L.Marker.prototype.options.icon = MAPS_CONFIG.FinishPointIcon;
L.drawLocal.draw.toolbar.buttons = MAPS_CONFIG.draw.toolbar.buttons;
L.drawLocal.edit.toolbar.buttons = MAPS_CONFIG.edit.toolbar.buttons;
L.drawLocal.edit.handlers.remove.tooltip = "";
L.Polyline.prototype.options.opacity = 1;
L.Polygon.prototype.options.color= "blue";
L.Polygon.prototype.options.fillColor= "transparent";
 

// MapBaseLayout Component
const MapBaseLayout = ({
  zoom,
  center,
  geoJsonData = null,
  featureGroupChildren = "",
  children = "",
  onMapCreate = null,
  onFeatureGroupCreate = null,
  style = {},
  ...rest
}) => {
  const [map, setMap] = useState(null);
  const [featureGroupRef, setFeatureGroupRef] = useState(null);
  const { holesData = [], holeIndex = 0 } = rest;

  // Initialize map
  const handleMapInit = (_map) => {
    setMap(_map);
    if (onMapCreate) onMapCreate(_map);
  };

  // Update map center and zoom
  useEffect(() => {
    if (map && center && zoom) {
      map.setView(center, zoom);
    }
  }, [map, center, zoom]);

  // Render GeoJSON data
  useEffect(() => {
    if (!featureGroupRef) return;

    if (Array.isArray(geoJsonData)) {
      geoJsonData.forEach((_d) => renderGeoJson(_d, featureGroupRef));
    } else if (holesData.length > 0) {
      holesData.forEach((hole, index) => {
        if (hole && hole.coordinate) {
          if (index === holeIndex) {
            renderGeoJson(geoJsonData, featureGroupRef);
          } else {
            renderGeoJson(hole.coordinate, featureGroupRef);
          }
        }
      });
    }
  }, [geoJsonData, holesData, holeIndex, featureGroupRef]);

  // Cleanup previous layers
  useEffect(() => {
    return () => {
      if (geoJsonData && featureGroupRef) {
        cleanPreviousHoleLayers(geoJsonData, featureGroupRef);
      }
    };
  }, [geoJsonData, featureGroupRef]);

  // FeatureGroup ref callback
  const _onFeatureGroupReady = useCallback(
    (reactFGRef) => {
      if (!featureGroupRef && reactFGRef) {
        setFeatureGroupRef(reactFGRef);
        if (onFeatureGroupCreate) onFeatureGroupCreate(reactFGRef);
      }
    },
    [featureGroupRef, onFeatureGroupCreate]
  );

  return (
    <MapContainer
      center={center}
      zoom={zoom}
      attributionControl={false}
      dragging
      animate
      whenCreated={handleMapInit}
      style={style}
      {...rest}
    ><FullscreenControl
    position="bottomright"
    {...MAPS_CONFIG.fullscreenOptions}

  />
  <FeatureGroup ref={_onFeatureGroupReady}>
        {featureGroupChildren}
      </FeatureGroup>
  {children}

      <LayersControl position="topleft">
        <LayersControl.BaseLayer checked name="Satellite View">
          <TileLayer url={MAPS_CONFIG.maptiler[MAPS_CONFIG.source[0]].url} />
        </LayersControl.BaseLayer>

        <LayersControl.BaseLayer name="Street View">
          <TileLayer url={MAPS_CONFIG.maptiler[MAPS_CONFIG.source[1]].url} />
        </LayersControl.BaseLayer>
      </LayersControl>
  {/* 


      <FeatureGroup ref={_onFeatureGroupReady}>
        {featureGroupChildren}
      </FeatureGroup>

       */}
    </MapContainer>
  );
};

export default MapBaseLayout;
